function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 10"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.848 22.47l-6.994-11.49a1 1 0 00-1.709 0l-.965 1.585-2.806-5.05a.998.998 0 00-.374-.38v-2.38l4.711-1.347a.425.425 0 000-.816L11 1.245V1a1 1 0 00-2 0v6.134a.998.998 0 00-.37.373l-8.5 15A1 1 0 001 24c22.834-.042 21.952.079 22.33-.056a1 1 0 00.518-1.474zM9.996 9.152L12.134 13H7.816zM6.682 15h6.563l.003.004a.988.988 0 00.038.07l1.34 2.411a1 1 0 101.748-.97l-1.076-1.938.702-1.154L21.22 22H2.717z"
})));